import { BaseValidator } from './base';
import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { VALID_ORDER } from 'apps/action_types';
import { FSA }                from 'flux-standard-action';
import { update }             from 'apps/actions/data';
import { deepmerge }          from 'utilities/merge';
import isEmail                from 'validator/lib/isEmail';
import isEmpty                from 'validator/lib/isEmpty';
import { newDataFromDot }     from 'utilities/hash';

class OrderValidator extends BaseValidator {
  properties = [
                 'client_id', 'user_id', 'product_id', 'job_no'
               ];
  validClient(){
    let name = this.newVal.inputs.client_id.value;
    let isValid = this.require('client_id', this.messages.common.require_one)
    if(!isValid){
      this.newVal.error = true;
    }
  }
  validProduct(){
    let name = this.newVal.inputs.product_id.value;
    let isValid = this.require('product_id', this.messages.common.require_one)
    if(!isValid){
      this.newVal.error = true;
    }
  }
  validUser(){
    let name = this.newVal.inputs.user_id.value;
    let isValid = this.require('user_id', this.messages.common.require_one)
    if(!isValid){
      this.newVal.error = true;
    }
  }
  validJobNo(){
    let job_no = this.newVal.inputs.job_no.value;
    let isValid = true;
    if(job_no != ''){
      isValid = this.isRegex('job_no', this.messages.order.job_no.regex, /^\d{7}(,\d{7})*$/)
    }
    if(!isValid){
      this.newVal.error = true;
    }
  }
  uniqueJobnos = function*(){
    let job_no   = this.newVal.inputs.job_no.value;
    let order_id = this.newVal.order_id;
    let at      = this.newVal.inputs.job_no.authenticity_token;
    let exception = this.newVal.inputs.job_no.exception;
    let callParams = { job_no: job_no, user_id: order_id, at: at, exception: exception};
    let { data, error } = yield call(api.validUniqueJobno, callParams);
    let message;
    if(data && !data.isValid){
      this.newVal.error = true;
      message = this.messages.order.job_no.unique;
    } else if(error){
      this.newVal.error = error;
      message = this.messages.commons.error_500;
    }
    this.addMessage(this.newVal.inputs.job_no, message);
    return this.newVal
  }
}
export const validOrder = function*(){
  yield takeEvery(VALID_ORDER, function*(action: FSA<any, any>){
    let validator;
    validator = new OrderValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    if(validator.targetIs('client_id')){ validator.validClient(); }
    if(validator.targetIs('product_id')){ validator.validProduct(); }
    if(validator.targetIs('user_id')){ validator.validUser(); }
    if(validator.targetIs('job_no')){
      validator.validJobNo();
      if(!newVal.error){
        yield validator.uniqueJobnos();
      }
    }
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    yield put(update(newData));
    validator.done();
  });
}
